import { AxiosError, AxiosRequestConfig, AxiosResponse, Method } from 'axios';
import { BaseAPIClient } from '../../core/src/api';

let apiClient: BaseAPIClient | null = null;

export function setKubbApiClient(_apiClient: BaseAPIClient) {
  apiClient = _apiClient;
}

export function getKubbApiClient() {
  if (!apiClient) {
    throw new Error('ApiClient not set');
  }

  return apiClient;
}

export const createKubbApiClient = (slug: string, passedBaseUrl?: string) => {
  const customBaseURL = (import.meta.env as Record<string, string>)[`VITE_API_ROOT_${slug.toUpperCase().replace(/-/g, '_')}`];
  const defaultBaseURL = `${import.meta.env.VITE_API_ROOT}/${slug}`;
  const baseURL = passedBaseUrl ?? customBaseURL ?? defaultBaseURL;

  if (customBaseURL) {
    console.log('Using custom base URL for', slug, customBaseURL);
  }

  const client = async <TData, TError = unknown, TVariables = unknown>(
    config: RequestConfig<TVariables>,
  ): Promise<AxiosResponse<TData>> => {
    return getKubbApiClient()
      .request<TData>(config.method as Method, config.url as string, {
        ...config,
        baseURL,
      })
      .catch((e: AxiosError<TError>) => {
        throw e;
      });
  };

  client.generateUrl = (url: string, params?: object) => getKubbApiClient().generateUrl(baseURL + url, { prependBaseURL: false, secure: true, params });

  return client;
};

/**
 * Subset of AxiosRequestConfig
 */
export type RequestConfig<TData = unknown> = {
  baseURL?: string;
  url?: string;
  method?: 'GET' | 'PUT' | 'PATCH' | 'POST' | 'DELETE' | 'OPTIONS' | 'HEAD';
  params?: unknown;
  data?: TData | FormData;
  responseType?:
    | 'arraybuffer'
    | 'blob'
    | 'document'
    | 'json'
    | 'text'
    | 'stream';
  signal?: AbortSignal;
  headers?: AxiosRequestConfig['headers'];
};

/**
 * Subset of AxiosResponse
 */
export type ResponseConfig<TData = unknown> = {
  data: TData;
  status: number;
  statusText: string;
  headers: AxiosResponse['headers'];
};

export type ResponseErrorConfig<TError = unknown> = AxiosError<TError>;

export type Client = ReturnType<typeof createKubbApiClient>;
